import clsx from 'clsx';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import Itinerary from './Itinerary';
import Packages from './Packages';
import styles from './PackagesContainer.module.scss';
import type { Accommodation } from 'types/Quote';
import type {
  ClinicPackagesCollection,
  ClinicTreatmentEntry,
  TreatmentEntry,
} from 'types/Clinic';

type Props = {
  entry: ClinicTreatmentEntry[];
  itineraryText: string | undefined;
  accommodation?: Accommodation;
};

const PackagesContainer = ({
  entry,
  itineraryText,
  accommodation,
}: Props): JSX.Element | null => {
  const { query } = useRouter();

  const [packages, setPackages] = useState<ClinicPackagesCollection | null>(
    null,
  );
  const [treatment, setTreatment] = useState<TreatmentEntry | null>(null);
  const [currentTreatment, setCurrentTreatment] = useState(0);
  const [treatments, setTreatments] = useState<ClinicTreatmentEntry[] | null>(
    [],
  );

  useEffect(() => {
    const { packages, treatment } = entry[0] || {};

    setPackages(packages);
    setTreatment(treatment);
    setTreatments(entry);
  }, [query.locale, query.page]);

  const updateTreatment = (index: number): void => {
    if (!treatments) {
      return;
    }

    const { packages, treatment } = treatments[index];

    setCurrentTreatment(index);
    setPackages(packages);
    setTreatment(treatment);
  };

  if (!treatment) {
    return null;
  }

  return (
    <div className="bg-secondary-bright border-t border-silver-light mt-24">
      <div className="max-w-screen-xl mx-auto relative">
        {!!treatments?.length && (
          <ul className={clsx(styles.menu, 'flex px-3 w-full overflow-x-auto')}>
            {treatments?.filter(Boolean).map((item, i) => (
              <li
                key={i}
                className={clsx(
                  styles.tab,
                  'px-4 border border-silver-light mr-3 text-0-815r font-bold text-navy uppercase flex items-center rounded-tl-lg rounded-tr-lg tracking-wider cursor-pointer shrink-0',
                  currentTreatment === i
                    ? ['bg-secondary-bright', styles.active]
                    : 'bg-white',
                )}
                onClick={() => updateTreatment(i)}
              >
                {item?.treatment?.name}
              </li>
            ))}
          </ul>
        )}

        {!!packages?.items.length && treatment && (
          <>
            <Packages packages={packages} treatment={treatment} />
            <Itinerary
              itineraryText={itineraryText}
              accommodation={accommodation}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default PackagesContainer;
